/* eslint-disable max-len */
export default {
	'Subaru Express Service':
		'.ws-subaru-prgrm-logos a[href*="/subaru-express-service.htm"]',
	'Trade Up Advantage':
		'.ws-subaru-prgrm-logos a[href*="/trade-up-advantage.htm"]',
	'Certified Subaru Eco-Friendly Retailer':
		'.ws-subaru-prgrm-logos a[href*="/eco-friendly-retailer-program.htm"]',
	'CPO Logo':
		'.ws-subaru-prgrm-logos a[href*="/certified-inventory/index.htm"]',
	'Retailer Program Widget': '.ws-subaru-prgrm-logos a',
	'2022 Subaru Outback Wilderness':
		'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/2022-subaru-outback-wilderness-launch.htm"]',
	'Subaru Consumer Reports':
		'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/consumer-reports.htm"]',
	'Industry Reviews & Awards':
		'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/subaru-awards.htm"]',
	'Subaru Incentives, Rebates, Specials':
		'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/global-incentives/index.htm"]',
	'Meet the Barkleys':
		'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/meet-the-barkleys.htm"]',
	'Love Promise':
		'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/subaru-love-promise.htm"]',
	'Corporate Cell Cards':
		'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a',
	aspca: '.ws-subaru-stl #aspca a.national-charity-btn',
	maw: '.ws-subaru-stl #maw a.national-charity-btn',
	mow: '.ws-subaru-stl #monw a.national-charity-btn',
	npf: '.ws-subaru-stl #npf a.national-charity-btn',
	hometown: '.ws-subaru-stl a[href*="/share-the-love/submission-form.html"]',
	'Share The Love': '.ws-subaru-stl a.national-charity-btn',
	'Awards and Accolades': '[data-web-api-id="subaruawards-badgeprice"] a',
	CPO: '.badge-callout a.certified, .badge-callout .certified a',
	Starlink: 'a.subaru-starlink, .subaru-starlink a',
	Eyesight: 'a.subaru-eyesight, .subaru-eyesight a',
	'Maintain the Love': 'a.mtl-badge, .mtl-badge a',
	'CR Trust Mark': 'a.trustmark-link, .trustmark-link a',
	'Flex Banner': 'a.soa-wiapi-footer-banner'
};
